/*
 * @version: V1.0.0
 * @Date: 2022-12-05 15:18:22
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-31 14:26:04
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\utils\validate.js
 * @Descripttion:
 */
import loadsh from 'lodash'
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

// 表单rule长度超长校验
export function validateLength(rule, value, callback) {
  if (value && value.length > rule.maxLength) {
    callback(new Error(`${rule.key}不能超过${rule.maxLength}位`))
  } else {
    callback()
  }
}

// 表单单项校验
export function validateFormElement(keyList, form) {
  return keyList.map((key) => {
    return new Promise((resolve, reject) => {
      form.validateField(key, (error) => {
        if (error) {
          reject()
        } else {
          resolve(true)
        }
      })
    })
  })
}

// 校验小数点位数与长度
export function validateNumberLength(number, length, decimalPlaces) {
  const num = typeof number === 'string' ? Number(number) : number
  const regex = new RegExp(`^\\d{1,${length}}(\\.\\d{1,${decimalPlaces}})?$`)
  return regex.test(num)
}

/**
 * 校验定位
 * @param object
 */
export function verifyLocation() {
  try {
    setTimeout(() => {
      const isError = document.getElementsByClassName('is-error')
      if (isError && isError[0].querySelector('input')) {
        isError[0].querySelector('input').focus()
      } else if (isError && isError[0].querySelector('textarea')) {
        isError[0].querySelector('textarea').focus()
      }
    }, 50)
  } catch (e) {
    console.log(e)
  }
}

// 校验是否存在
export function checkExist(value) {
  if (value === '0') {
    return true
  }
  return !!value
}

// 校验长度是否合规
export function checkLength(value, length) {
  if (value) {
    return value.length === length
  }
  return true
}

// 校验已填标识是否与当前厂商识别代码一致
export function checkVendorCode(value) {
  const vendorCode = sessionStorage.getItem('vendorCode')
  if (value) {
    return value.substring(1, vendorCode.length + 1) === vendorCode
  }
  return true
}

// 校验正则验证,pattern为正则表达式
export function checkRegular(data, options) {
  const res = []
  options.forEach((cur) => {
    const value = loadsh.get(data, cur.key)
    if (!value) return
    if (!cur.pattern.test(loadsh.trim(value))) {
      res.push(`${cur.sheet},序号为${data.serial ? data.serial : '空'}的产品,${cur.errorMessage}`)
    }
  })
  return res
}

// 校验内容是否重复
export function checkRepeat(data, dataList, options) {
  const res = []
  options.forEach((cur) => {
    const value = loadsh.get(data, cur.key)
    if (!value) return
    const filterList = dataList
      .filter((item) => item.serial === data.serial)
      .filter((item, index, self) => {
        return self.some((innerItem, innerIndex) => {
          return innerIndex !== index && innerItem[cur.key] === item[cur.key]
        })
      })
    if (filterList.length > 0) {
      res.push(`${cur.sheet},序号为${data.serial ? data.serial : '空'}的产品,${cur.errorMessage}`)
    }
  })

  return res
}

// 校验是否存在
export function customValidate(data, options, message) {
  const res = []
  options.forEach((cur) => {
    const value = loadsh.get(data, cur.key)
    if (value === null || value === undefined || value === '') {
      res.push(
        `${message}序号为${data.serial ? data.serial : '空'}的产品 存在【${cur.value}】为空的项`
      )
    }
  })
  return res
}

// 校验序号是否存在
export function customSerial(serial, index, message) {
  const res = []
  if (serial === null || serial === undefined || serial === '') {
    res.push(`${message},第${index + 1}行的产品，序号为空`)
  }
  return res
}

// 获取序号去重后的数据
export function weightlessnessReduction(list, message, type) {
  const arr = list.filter((item) => item.indexOf(message) !== -1)
  const regex = type === 'import' ? /序号为(\d+)/ : /序号:(\d+)/
  console.log(message, arr)
  const serialList = arr
    .map((str) => {
      const match = str.match(regex)
      return match ? match[1] : 0
    })
    .filter((value, index, self) => {
      return self.indexOf(value) === index
    })

  return serialList
}
